import { Vector3, Object3D, SphereGeometry, MeshBasicMaterial, Mesh, ArrowHelper } from 'three';
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import Tooth from '../Model/Tooth';

const POINT_KEYS = ['centralPit', 'distal', 'mesial', 'rotationRoot'];
const VECTOR_KEYS = ['vecRoot', 'vecVestibularLingual', 'vecRidge', 'vecArchTemplateNormal', 'vecArchTemplateTangent', 'vecTangentToFacial'];

const COLOR_MAP = {
    tip: 0xffff00,
    centralPit: 0x00ff00,
    mesial: 0xff0000,
    distal: 0x800080,
    vecRidge: 0x00ff00,
    vecRoot: 0xff0000,
    vecVestibularLingual: 0xffff00,
};

const getColor = (key) => COLOR_MAP[key] ?? 0xff0000;

const buildPointSphere = (tooth, key, coords) => {
    const geometry = new SphereGeometry(0.5, 20, 20);
    const material = new MeshBasicMaterial({ color: getColor(key) });
    const sphere = new Mesh(geometry, material);
    sphere.position.set(coords[0], coords[1], coords[2]);
    sphere.layers.set(tooth.jawSide);
    sphere.visible = false;
    tooth.refObj.add(sphere);

    tooth.pointSpheres[key] = sphere;
    tooth.pointSpheres[key].userData = { type: key };

    if (key === 'centralPit') tooth.centralPit = sphere;
    if (key === 'rotationRoot') tooth.rotationRoot = sphere;
};

const buildVectorArrow = (tooth, key, coords) => {
    const origin = new Vector3(0, 0, 0);
    const direction = new Vector3(coords[0], coords[1], coords[2]);
    const length = direction.length();
    const arrowHelper = new ArrowHelper(direction.normalize(), origin, length, getColor(key));

    arrowHelper.name = key;
    arrowHelper.visible = false;
    arrowHelper.raycast = () => {};
    tooth.refObj.add(arrowHelper);

    tooth.vectors[key] = arrowHelper;
};

const buildBaryCenter = (tooth, coords) => {
    if (!Tooth._sharedSphereGeometry) {
        Tooth._sharedSphereGeometry = new SphereGeometry(0.1, 20, 20);
    }
    const material = new MeshBasicMaterial({ color: 0x0000ff });
    const sphere = new Mesh(Tooth._sharedSphereGeometry, material);

    sphere.position.set(coords[0], coords[1], coords[2]);
    sphere.layers.set(tooth.jawSide);
    sphere.visible = false;
    tooth.refObj.add(sphere);

    tooth.baryCenter = sphere;
    tooth.pointSpheres.baryCenter = sphere;
    tooth.pointSpheres.baryCenter.userData = { type: 'baryCenter' };
};

export const buildToothVisuals = (tooth, coords, scene) => {
    Object.entries(coords).forEach(([key, value]) => {
        if (POINT_KEYS.includes(key)) {
            buildPointSphere(tooth, key, value);
        } else if (key === 'barycenter') {
            buildBaryCenter(tooth, value);
        } else if (VECTOR_KEYS.includes(key)) {
            tooth[key] = new Vector3(value[0], value[1], value[2]);
            buildVectorArrow(tooth, key, value);
        }
    });

    tooth.hideAllPoints();
    initializePivot(tooth, scene);
};

const initializePivot = (tooth, scene) => {
    tooth.pivot = new Object3D();
    tooth.pivot.layers.set(tooth.jawSide);

    const mandiGroup = threeEngine.getMandiGroup();
    if (tooth.jawSide === 1 && mandiGroup) {
        mandiGroup.add(tooth.pivot);
    } else {
        scene.add(tooth.pivot);
    }
};
